import { Component, Prop, Vue } from 'vue-property-decorator'

import BadgePerson from '@/components/BadgePerson/index.vue'
import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import tableHelper from '@/helpers/table'

@Component({
	components: {
		BadgePerson,
	},
})
export default class RatingDeadlineCard extends Vue {
	@Prop({ required: true }) readonly rating

	formatCNJ(val) {
		return tableHelper.formatCNJ(val)
	}

	statusColor(status) {
		if (status === 'Insatisfatório') return 'alert-danger'
		else if (status === 'Regular') return 'alert-warning'
		else if (status === 'Bom') return 'alert-secondary'
		else if (status === 'Ótimo') return 'alert-info'
		else if (status === 'Excelente') return 'alert-success'
	}
}
